import Component from '../abstracts/Component';
import TrackingComponent from '../components/TrackingComponent';
export default class PasswordRecoveryLogic extends Component {

  constructor(compEl) {
    super(compEl);
    this.TrackingComponent = new TrackingComponent();
  }

  passwordRecovery(e){
    let ctx = e.event.data;
    e.event.preventDefault();
    let $this = e.event.target;
    let url = e.event.target.getAttribute('action');
    let btn = ctx.$component.querySelector(ctx.SELECTORS.submitButton);
    let params = new URLSearchParams(new FormData($this)).toString();

    ctx.$doAjax({
        type: 'POST',
        url: url,
        data: params
    })
    .done(res => {
        ctx.log('Recovery password...');
        let html = new DOMParser ().parseFromString(res, 'text/html');
        newsletterBox.classList.add(ctx.CLASSES.success);
        // emit event
        //ctx.$emit(ctx.$customEvents[eventsName].subscribed, {box: newsletterBox});
        // removing loading class
        newsletterBox.classList.remove('loading');
    })
    .fail(xhr => {
        console.log(`nl submit error:  ${$(this).serialize()}`);
        console.log(xhr);
    })
    .always(() => {
        console.log("finished")
    });

  }

  /*

  // subscribe function
  subscribeToNewsletter(e) {
    // vars
    let $this = e.event.target; // form
    let url = e.event.target.getAttribute('action'); // form url
    let btn = ctx.$component.querySelector(ctx.SELECTORS.submitButton);
    let privacyCheckbox = ctx.$component.querySelector(ctx.SELECTORS.privacyCheckbox);
    let input = ctx.$component.querySelector(ctx.SELECTORS.input);
    let inputBox = ctx.$component.querySelector(ctx.SELECTORS.inputBox);
    let label = ctx.$component.querySelector(ctx.SELECTORS.label);
    let params = new URLSearchParams(new FormData($this)).toString();
    let newsletterBox = ctx.$component;
    let eventsName = ctx.$component.dataset.jsEvents;
    let $submit = ctx.$component.querySelector(ctx.SELECTORS.submitButton);
    let formWrapper = ctx.$component.querySelector(ctx.SELECTORS.formWrapper);
    // btn loading
    // btn.classList.add('button--loading');
    // btn.disabled = true;
    // modal mode
    // adding loading class
    // newsletterBox.classList.add('loading');
    // show spinner loader
    ctx.$emit(ctx.$customEvents.LOADER_EVENTS.showLocal, {
      button: btn,
    });

    console.log(input.value);
    console.log(privacyCheckbox);
    console.log(formWrapper);
    console.log(inputBox);
    // console.log(intrendCheckbox);

    if (!emailRegex.test(input.value)) {
        formWrapper.classList.add('email-error');
    } else {
        formWrapper.classList.remove('email-error');
        correctEmail = true;
    }


    if (!privacyCheckbox.checked) {
        privacyCheckbox.parentElement.classList.add('checkbox-error');
    } else {
        privacyChecked = true;
        privacyCheckbox.parentElement.classList.remove('checkbox-error');
    }

    // ajax call
    if(correctEmail && privacyChecked){
        ctx.$doAjax({
            type: 'POST',
            url: url,
            data: params
        })
        .done(res => {
            ctx.log('Newsletter modal going...');
            let html = new DOMParser ().parseFromString(res, 'text/html');
            let alreadySubcribed = (html.querySelector('div.form-error') !== null);
            // parse result
            // searching errors
            let error = ( html.querySelector('span.error') !== null  ) ;
            // error
            if (error) {
            // putting error class
            $this.querySelector(ctx.SELECTORS.input).classList.add('error');
            let spanError = html.querySelector('span.error');
            // insert error span
            if ($this.querySelector(ctx.SELECTORS.input).parentNode.querySelector('span.error') == null) {
                $this.querySelector(ctx.SELECTORS.input).parentNode.appendChild(spanError);
            }
            ctx.log('Newsletter modal error');
            // emit event
            ctx.$emit(ctx.$customEvents[eventsName].error, {box: newsletterBox ,html: html});
            // btn reset
            btn.classList.remove('button--loading');
            btn.disabled = false;
            } else if (!alreadySubcribed) {
            ctx.log('Newsletter modal success');
            // adding class to show thanks
            newsletterBox.classList.add(ctx.CLASSES.success);
            // emit event
            ctx.$emit(ctx.$customEvents[eventsName].subscribed, {box: newsletterBox});
            let trackingComponent = new TrackingComponent();
            trackingComponent.trackAction('newsletterSubscribe', $submit.dataset , $submit);
            }
            // removing loading class
            newsletterBox.classList.remove('loading');
        })
        .fail(xhr => {
            console.log(`nl submit error:  ${$(this).serialize()}`);
            console.log(xhr);
        })
        .always(() => {
            // removing loading class
            newsletterBox.classList.remove('loading');
            // hide spinner loader
            ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, {
            button: btn,
            });
        });
    }
    //   newsletter classlist add errore
  }

  afterSubscription(component) {
    let ctx = component;
    // elems
    let thanksTitle = ctx.$component.querySelector(ctx.SELECTORS.thanksTitle);
    if ( thanksTitle != null ) {
      let thanksTitleString = thanksTitle.getAttribute('data-attr');
      if ( thanksTitleString != null ) {
        let thanksTitleContent = thanksTitleString.replace('{%1}', ctx.$component.querySelector(ctx.SELECTORS.firstName).value);
        // put thanks label
        thanksTitle.innerHTML = thanksTitleContent;
      }
    }
  }
  */

  render() {
    this.log('Load logics...');
  }
}
